import { createBooleanFeatureFlag, createFeatureFlagConfig, createRemoteFeatureFlag } from './featureFlags.factories';

export const FEATURE_FLAG_VALUES = {
  layout: createFeatureFlagConfig('layout', ['aloha', 'brannan']),
  guestsitetarget: createFeatureFlagConfig('guestsitetarget', ['bliss', 'charm']),
  nossr: createBooleanFeatureFlag('nossr'),
  joyWeb: createFeatureFlagConfig('joy-web', true),
  pseudoLocalization: createFeatureFlagConfig('pseudoloc', ['true', 'all']),
  addCashGift: createBooleanFeatureFlag('addcashgift'),
  registryGiftTracking: createBooleanFeatureFlag('registryGiftTracking'),
  bookmarkletPopup: createBooleanFeatureFlag('bookmarkletPopup'),
  productPromoFeed: createBooleanFeatureFlag('productPromoFeed'),
  externalRegistry: createBooleanFeatureFlag('externalRegistry'),
  enableRegistryPasswordUnlock: createBooleanFeatureFlag('enableRegistryPasswordUnlock'),
  disableRegistryPhotoUpload: createBooleanFeatureFlag('disableregistryphotoupload'),
  enableSsr: createBooleanFeatureFlag('enablessr'),
  enableCurationHero: createBooleanFeatureFlag('enableCurationHero'),
  enableCurationHeroVideo: createBooleanFeatureFlag('enableCurationHeroVideo'),
  giftReservation: createFeatureFlagConfig('giftReservation', ['true', 'r3', 'r4']),
  compactBuildPage: createBooleanFeatureFlag('compactBuildPage'),
  enableProductColorSwatch: createBooleanFeatureFlag('enableProductColorSwatch'),
  enableCountryDropdown: createBooleanFeatureFlag('enableCountryDropdown'),
  tileColorSwatchInteraction: createFeatureFlagConfig('tileColorSwatchInteraction', ['hover', 'click', 'hover-n-click']),
  doRegistryOnboardingCardsReset: createBooleanFeatureFlag('doRegistryOnboardingCardsReset'),
  enableNewCurationGrid: createBooleanFeatureFlag('enableNewCurationGrid'),
  enableRegistryOnboardingSurveyDialog: createBooleanFeatureFlag('enableRegistryOnboardingSurveyDialog'),
  registryOnboardingSurvey: createFeatureFlagConfig('registryOnboardingSurvey', ['force', 'reset', 'force5']),
  enableFullstoryTracking: createBooleanFeatureFlag('enableFullstoryTracking'),
  enableRegistryTransfer: createBooleanFeatureFlag('enableRegistryTransfer', true),
  enableCreateWeddingProgressBar: createBooleanFeatureFlag('enableCreateWeddingProgressbar'),
  enableClearCartFeature: createBooleanFeatureFlag('enableClearCartFeature'),
  enableHaveYouPurchasedModal: createBooleanFeatureFlag('enableHaveYouPurchasedModal', true),
  enableHaveYouPurchasedModalExternalLinkClick: createBooleanFeatureFlag('enableHaveYouPurchasedModalExternalLinkClick', true),
  enableCashFundCheckoutV2: createBooleanFeatureFlag('enableCashFundCheckoutV2', true),
  enableLoadingStyleApplicator: createBooleanFeatureFlag('enableLoadingStyleApplicator'),
  enableAddressVerificationModal: createBooleanFeatureFlag('enableAddressVerificationModal'),
  enableQuickAddLandingPage: createBooleanFeatureFlag('enableQuickAddLandingPage'),
  enableAddEditGiftNote: createBooleanFeatureFlag('enableAddEditGiftNote', true),
  enableOnboardingSurveyV2: createBooleanFeatureFlag('enableOnboardingSurveyV2', true),
  enableOnboardingExperimentBypass: createBooleanFeatureFlag('enableOnboardingExperimentBypass'),
  enableCurationHomeExpert: createBooleanFeatureFlag('enableCurationHomeExpert', true),
  enableRegistryTransferV2: createBooleanFeatureFlag('enableRegistryTransferV2', true),
  enableBuyForMyselfFromPurchaseConfirmation: createBooleanFeatureFlag('enableBuyForMyselfFromPurchaseConfirmation', true),
  enableRandomLabelsGuestRegistryProducts: createBooleanFeatureFlag('enableRandomLabelsGuestRegistryProducts'),
  enableSplitPurchaseDialog: createBooleanFeatureFlag('enableSplitPurchaseDialog', true),
  enableShippingAddressWarning: createBooleanFeatureFlag('enableShippingAddressWarning', true),
  orderTrackingFeature: createBooleanFeatureFlag('orderTrackingFeature', true),
  enableMFASettings: createBooleanFeatureFlag('enableMFASettings', true),
  enableRegistryCompletionDiscount: createBooleanFeatureFlag('enableRegistryCompletionDiscount', true),
  enableCurationsSection: createBooleanFeatureFlag('enableCurationsSection', true),
  enableAffiliateCheckoutV2: createBooleanFeatureFlag('enableAffiliateCheckoutV2', true),
  shoppingCartV2: createBooleanFeatureFlag('shoppingCartV2', true),
  enableNewExternalRegistry: createBooleanFeatureFlag('enableNewExternalRegistry'),
  enableGroupGifting: createBooleanFeatureFlag('enableGroupGifting', true),
  showGroupGiftingCheckbox: createBooleanFeatureFlag('showGroupGiftingCheckbox', true),
  enableChecklistInGiftBasketWidget: createBooleanFeatureFlag('enableChecklistInGiftBasketWidget', true),
  enableBlankDates: createBooleanFeatureFlag('enableBlankDates', true),
  enableCustomEventName: createBooleanFeatureFlag('enableCustomEventName', true),
  enableExplodedCategoryV2: createBooleanFeatureFlag('enableExplodedCategoryV2', true),
  enableBabyRegistry: createBooleanFeatureFlag('enableBabyRegistry'),
  enableCreditCard: createBooleanFeatureFlag('enableCreditCard'),
  enableNewNavMenu: createBooleanFeatureFlag('enableNewNavMenu', true),
  guestSiteSafeLinks: createBooleanFeatureFlag('guestSiteSafeLinks', true),

  /**
   * Is being AB tested
   */
  enableShopNavInManage: createBooleanFeatureFlag('enableShopNavInManage'),
  enableNewRegistryOverview: createBooleanFeatureFlag('enableNewRegistryOverview', true),
  enableGalleryLightbox: createBooleanFeatureFlag('enableGalleryLightbox', true),
  enableScrollbarV2: createBooleanFeatureFlag('enableScrollbarV2', true),
  adminDashboardNoRegistryIntentAd: createBooleanFeatureFlag('adminDashboardNoRegistryIntentAd'),
  adminDashboardTodayCardsByDefaultV2: createBooleanFeatureFlag('adminDashboardTodayCardsByDefaultV2'),
  websiteGuestRegistryAd: createBooleanFeatureFlag('websiteGuestRegistryAd'),
  postRegistrySurveyLandingExperiment: createBooleanFeatureFlag('postRegistrySurveyLandingExperiment', true),
  enableCatalogCustomerReviews: createBooleanFeatureFlag('enableCatalogCustomerReviews'),
  /**
   * Prevent using cached SSR html.
   */
  skipSsrCache: createBooleanFeatureFlag('skipssrcache'),
  logSsrUserAgent: createBooleanFeatureFlag('logSsrUserAgent'),

  exampleOnOffRemoteFeatureFlag: createRemoteFeatureFlag('exampleOnOffFeatureFlag'),
  exampleMultiVariantRemoteFeatureFlag: createRemoteFeatureFlag({ key: 'examplemultivariantfeatureflag', supportedValues: ['variant1', 'variant2'], defaultValue: 'variant1' }),
  exampleExperimentFeatureFlag: createRemoteFeatureFlag({ key: 'exampleexperimentfeatureflag', supportedValues: ['control', 'treatment'] }),
  adminDashboardAATestExperiment: createRemoteFeatureFlag({ key: 'adminDashboardAATestExperiment', supportedValues: ['control', 'treatment'] }),
  /*
   * Gift Wrap Remote Feature Flags
   */
  registryGiftWrapEcardPrice: createRemoteFeatureFlag('registrygiftwrapecardprice'),
  registryGiftWrapCartEnabled: createRemoteFeatureFlag('registrygiftwrapCartenabled'),
  registryGiftWrapDropshipEnabled: createRemoteFeatureFlag('registrygiftwrapdropshipenabled'),
  registryGiftWrapExperimentEnabled: createRemoteFeatureFlag('registrygiftwrapexperimentenabled'),
  registryGiftWrapCashEnabled: createRemoteFeatureFlag('registrygiftwrapcashenabled'),
  registryGiftWrapAffiliateEnabled: createRemoteFeatureFlag('registrygiftwrapaffiliateenabled'),
  registryGiftTrackerThankYouManager: createRemoteFeatureFlag('registrygifttrackerthankyoumanager'),
  /*
   * Registry Admin Remote Feature Flags
   */
  fullstoryRecordRegistryAdminEnabled: createRemoteFeatureFlag('fullstoryrecordregistryadminenabled')
};

export type FeatureFlags = typeof FEATURE_FLAG_VALUES;
